import { render, staticRenderFns } from "./Osa007.vue?vue&type=template&id=1766e1b0&scoped=true"
var script = {}
import style0 from "./Osa007.vue?vue&type=style&index=0&id=1766e1b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1766e1b0",
  null
  
)

export default component.exports